export default __webpack_public_path__ + "static/media/case2.da3c19cc.jpg";